
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_12hwc_oboi4_5",
  "layout-strut": "awsui_layout-strut_12hwc_oboi4_9",
  "list-bottom": "awsui_list-bottom_12hwc_oboi4_15"
};
  